// extracted by mini-css-extract-plugin
export default {"container":"_1XzMZ","inModal":"_1aXZm","pimple":"_3RGM1","updatedIndicationText":"_19fY2"};